// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"49ccb12c","223":"01f96a6a","301":"1c97c313","573":"7d4cc4db","830":"f2f777e1","968":"f9681224"}[chunkId] + ".chunk.js";
};